import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { mobile } from "../../utilities/detection";
import DesktopContent from "./desktopContent";
import MobileContent from "./mobileContent";
import PreContentVideo from "../ads/preContentVideo";
import AdblockContentMessage from "../global/adblockContentMessage";
import { getString } from "../../utilities";
import Trouble from "./trouble";
import { fullScreen } from "../../utilities/games";
import Close from "../../../assets/svg/close.svg";
import Arrow from "../../../assets/svg/arrowRight.svg";
import { useDescription } from "../../hooks";
import { adsSelector } from "../../redux/slices/loginSlice";
import { fullScreenActiveSelector } from "../../redux/slices/userClientSlice";

export default function GameContent({ game, isMobileFree, isMobileActive, isArcademics, publicModalToggle }) {
  const fullScreenActive = useSelector(fullScreenActiveSelector);

  const ads = useSelector(adsSelector);
  const [prerollVideo, setPrerollVideo] = useState(false);

  const { descriptionClosed, descriptionTextContainer, showMoreDescription, setDescriptionClosed, setDescriptionMore } =
    useDescription();

  useEffect(() => {
    window.addEventListener("resize", setDescriptionMore);

    return () => {
      window.removeEventListener("resize", setDescriptionMore);
    };
  }, []);

  useEffect(() => {
    setPrerollVideo(!mobile && ads);
  }, [ads, game]);

  useEffect(() => {
    if (descriptionTextContainer.current && game?.description) {
      setDescriptionMore();
    }
  }, [descriptionTextContainer, game]);

  const renderCloseFullButton = () => {
    if (fullScreenActive) {
      return (
        <a
          onClick={() => {
            fullScreen.exit();
          }}
          className="game-fullscreen-close"
          alt={getString("navigation.fullscreen.exit")}
        >
          <Close />
        </a>
      );
    }

    return null;
  };

  const renderContent = () => {
    if (mobile) {
      return (
        <MobileContent
          game={game}
          isMobileFree={isMobileFree}
          isMobileActive={isMobileActive}
          isArcademics={isArcademics}
          publicModalToggle={publicModalToggle}
        />
      );
    }
    if (prerollVideo) {
      return <PreContentVideo toggle={setPrerollVideo} />;
    }
    return <DesktopContent game={game} isArcademics={isArcademics} />;
  };

  let directionStyle =
    (mobile && game?.mobileOrientation === "portrait") || game?.orientation === "portrait" ? "vertical" : "";
  if (isArcademics) directionStyle = "arcademics";
  const containerStyle = fullScreenActive ? "game-container-fullscreen" : "container";

  const prerollStyle = prerollVideo ? "prerollvideo" : "";

  return (
    <div className="game-description-wrapper">
      {/* supplies the overall width */}
      <div className="game-game-wrapper">
        {/* supplies the overall height */}

        <div id="game-container" className={`game-game ${directionStyle} ${prerollStyle}`}>
          {/* supplies the variant widths */}

          <div id="desktopGame" className={containerStyle}>
            {/* provides aspect ratio */}

            {renderContent()}

            <AdblockContentMessage message={getString("adblock.content", { replace: [getString("game.title.0")] })} />

            {renderCloseFullButton(game)}
          </div>
        </div>
      </div>

      <div className={`description ${descriptionClosed && "closed"}`}>
        <p className="description-text" ref={descriptionTextContainer}>
          {game?.description}
        </p>

        <div className={`description-more ${showMoreDescription && "active"}`}>
          <a
            onClick={() => {
              setDescriptionClosed((prev) => !prev);
            }}
          >
            {descriptionClosed ? getString("navigation.more.1") : getString("navigation.less.0")}&nbsp;
            <Arrow className="description-more-arrow" />
          </a>
        </div>

        <Trouble
          isMobileFree={isMobileFree}
          isMobileActive={isMobileActive}
          publicModalToggle={publicModalToggle}
          gameData={game ? { label: game.fullname, value: game.id } : null}
        />
      </div>
    </div>
  );
}

GameContent.propTypes = {
  game: PropTypes.object.isRequired,
  isMobileFree: PropTypes.bool.isRequired,
  isMobileActive: PropTypes.bool.isRequired,
  isArcademics: PropTypes.bool.isRequired,
  publicModalToggle: PropTypes.func.isRequired,
};
